import { BOOKING_STEPS, getPreviousStep, LandingMode } from '../constants/bookingSteps';
import { formatBookingDeposit } from '../constants/bookingDeposit';

export function canShowBackButton(
    currentStep: number,
    hasMultipleRooms: boolean,
    landingMode: LandingMode,
    showCalendar: boolean,
    includeSummaryStep = true
): boolean {
    if (currentStep === BOOKING_STEPS.SHOP) {
        return false;
    }

    if (currentStep === BOOKING_STEPS.TURN) {
        const canGoBackFromTurn =
            getPreviousStep(BOOKING_STEPS.TURN, hasMultipleRooms, landingMode, includeSummaryStep) !== null;
        return !showCalendar || canGoBackFromTurn;
    }

    return getPreviousStep(currentStep, hasMultipleRooms, landingMode, includeSummaryStep) !== null;
}

export function hasVisitedFurtherStep(currentStep: number, visitedSteps: Set<number>): boolean {
    return Array.from(visitedSteps).some((step) => step > currentStep);
}

export function canShowNextButton(currentStep: number, visitedSteps: Set<number>): boolean {
    if (currentStep === BOOKING_STEPS.PERSONAL_DATA) {
        return true;
    }

    if (currentStep === BOOKING_STEPS.EXTRAS || currentStep === BOOKING_STEPS.SUMMARY) {
        return true;
    }

    return hasVisitedFurtherStep(currentStep, visitedSteps);
}

export function getNextButtonLabel(currentStep: number): string {
    if (currentStep === BOOKING_STEPS.PERSONAL_DATA) {
        return `Pagar reserva (${formatBookingDeposit()})`;
    }

    if (currentStep === BOOKING_STEPS.SUMMARY) {
        return 'Confirmar';
    }

    if (currentStep === BOOKING_STEPS.EXTRAS) {
        return 'Continuar';
    }

    return 'Continuar';
}

export function shouldShowBookingBottomBar(
    currentStep: number,
    hasSelection: boolean,
    hasMultipleRooms: boolean,
    landingMode: LandingMode,
    showCalendar: boolean,
    visitedSteps: Set<number>,
    includeSummaryStep = true
): boolean {
    if (currentStep === BOOKING_STEPS.ROOM) {
        return false;
    }

    if (currentStep === BOOKING_STEPS.PERSONAL_DATA) {
        return true;
    }

    if (hasSelection && currentStep > BOOKING_STEPS.ROOM) {
        return true;
    }

    return (
        canShowBackButton(currentStep, hasMultipleRooms, landingMode, showCalendar, includeSummaryStep)
        || canShowNextButton(currentStep, visitedSteps)
    );
}
